import Qs from 'qs'

// 配置API接口地址
// baseURL = DWSystemSetting.baseURL
var baseURL
if (window.hasOwnProperty("DWSystemSetting")) {
  baseURL = DWSystemSetting.baseURL
}

// 自定义判断元素类型JS
function toType (obj) {
  return ({}).toString.call(obj).match(/\s([a-zA-Z]+)/)[1].toLowerCase()
}

// 引用axios
var axios = require('axios')

// http request 拦截器
axios.interceptors.request.use(
  config => {
    var token = localStorage.getItem('token');
    var url = window.location.host.split(':')[0];//页面路径
    // var url = '192.168.124.150' 
    console.log(url, DWSystemSetting.baseURL, DWSystemSetting.remoteURL);
    if (DWSystemSetting.baseURL && DWSystemSetting.baseURL.indexOf(url) != -1) {
      baseURL = DWSystemSetting.baseURL
    }
    if (DWSystemSetting.remoteURL && DWSystemSetting.remoteURL.indexOf(url) != -1) {
      baseURL = DWSystemSetting.remoteURL
    }
    if (!token) { // 判断是否存在token，如果存在的话，则每个http header都加上token
      token = sessionStorage.getItem("token")
    }
    config.headers.token = token
    config.headers.Accept = 'application/json, text/plain, */*'
    config.headers['Content-Type'] = 'application/x-www-form-urlencoded'
    return config
  },
  err => {
    return Promise.reject(err)
  }
)

// http response 拦截器
axios.interceptors.response.use(response => {
  if (response.data && !response.data.success) {
    if (parseInt(response.data.errCode) === 401) { //未登录或token已过期
      toLogin()
    }
    if (parseInt(response.data.errCode) === 302) { //未登录或token已过期
      toLogin()
    }
  }
  return response
}, err => {
  if (err.response) {
    if (err.response.status == 400) {
      console.error(err.response.data)
      return Promise.reject(null)
    } else if (err.response.status >= 300) {
      console.error(err.response.data)
      if (![400, 404].includes(err.response.status)) {
        toLogin()
      }
      return Promise.reject(null)
    }
  }
  return Promise.reject(err)
})

function realAxios (method, url, params, success, failure, headers) {
  axios({
    url: url,
    method: method,
    baseURL: baseURL,
    params: method === 'GET' ? params : null,
    data: method === 'POST' ? params : null,
    withCredentials: false, //表示跨域请求时是否需要使用凭证
    transformRequest: [function (data) {
      let dataType = toType(data)
      if (data && (dataType === 'object' || dataType === 'array')) {
        var newData = JSON.parse(JSON.stringify(data))
        Object.keys(newData).forEach((key) => {
          if (toType(newData[key]) === 'object' || toType(newData[key]) === 'array') {
            newData[key] = JSON.stringify(newData[key]) // 这里必须使用内置JSON对象转换
          }
        })
        return Qs.stringify(newData)
      }
      return data
    }],
    headers: headers ? headers : {}
  })
    .then(e => {
      let res = e.data
      if (success == undefined) {
        success = respon => { }
      } else if (getClass(success) != "Function") {
        err(url + " 参数异常！")
        err(success)
        return
      }

      if (failure == undefined) {
        failure = respon => { }
      }
      if (res.success == true) {
        success(res.data)
      } else {
        failure(res.data)
        err(url)
        if (!isempty(res.errorMsg)) {
          err(res.errorMsg)
        } else {
          err(res.data)
        }
        if (res.data == 'token无效或者已过期，请重新登录！') {
          toLogin()
          if (debugPage != undefined) {
            debugPage.$dialogMethod.openAgreeDialog('凭证失效', "token无效或者已过期，请重新登录！", undefined, undefined, false)
          }
        }
      }
    })
    .catch(err => {
      if (err) {
        console.error(err.stack)
        if (err.response) {
          if (err.response.status === 404) {
            toLogin()
          }
          console.log("err.response.data    ", err.response.data)
          console.log("err.response.status  ", err.response.status)
          console.log("err.response.headers ", err.response.headers)
        }

      }
    })
}
//发送的api列表
let axiosapisendlist = []
setInterval(() => {
  if (baseURL == undefined) {
    if (window.hasOwnProperty("DWSystemSetting")) {
      baseURL = DWSystemSetting.baseURL
    } else {
      return
    }
  }
  //定时发送请求
  axiosapisendlist.forEach(item => {
    realAxios(item.method, item.url, item.params, item.success, item.failure, item.headers)
  })
  axiosapisendlist.splice(0)
}, 100)
//拦截了短时间内的相同的请求
function apiAxios (method, url, params, success, failure, headers) {
  //过滤参数相同和接口相同的请求,不考虑回调
  var exist = axiosapisendlist.findIndex(item => {
    return item.url == url && JSON.stringify(params) == JSON.stringify(item.params)
  })
  if (exist == -1) {
    axiosapisendlist.push({
      method,
      url,
      params,
      success,
      failure,
      headers
    })
  }
}

//引用jsonp
var jsonp = require('jsonp')

function apiJsonp (url, params, success, failure) {
  url = baseURL + url
  for (var key in params) {
    if (url.indexOf('?') === -1) {
      url += '?'
      url += (key + '=' + params[key])
    } else {
      url += ('&' + key + '=' + params[key])
    }
  }
  jsonp(url, params, function (err, res) {
    if (err) {
      if (failure) {
        failure(err.message)
      }
      console.error(err.message)
    } else {
      if (!res.data && !res.msg) { //直接返回结果
        success(res)
      } else { //返回response结构{success:true,data:{},msg:''}
        if (res.success && res.data) {
          success(res.data)
        } else if (res.msg) {
          if (failure) {
            failure(res.msg)
          }

        }
      }
    }
  })
}

// 返回在vue模板中的调用接口
export default {
  baseURL: baseURL,
  get: function (url, params, success, failure, headers) {
    return apiAxios('GET', url, params, success, failure, headers)
  },
  post: function (url, params, success, failure, headers) {
    return apiAxios('POST', url, params, success, failure, headers)
  },
  jsonp: function (url, params, success, failure) {
    return apiJsonp(url, params, success, failure)
  },
  //这是返回当前使用的后台地址
  baseurl: function () {
    return baseURL
  }
}
